import React, { useRef } from 'react';
import useFullscreen from '../hooks/useFullscreen';
import useIframeWatchdog from '../hooks/useIframeWatchdog';

function Event() {
    const pageRef = useRef(null);
    const { isFullscreen, toggleFullscreen } = useFullscreen(pageRef);
    const videoId = 'M3-lzBgimyE';
    const src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&modestbranding=1&rel=0&playsinline=1&enablejsapi=1`;
    const { iframeSrc } = useIframeWatchdog(src);

    return (
        <div
            ref={pageRef}
            className="event-video-page"
            onDoubleClick={toggleFullscreen}
        >
            <iframe
                className="event-video-frame"
                src={iframeSrc}
                title="Event video"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
            />
            <button
                type="button"
                className="fullscreen-toggle-button"
                onClick={toggleFullscreen}
                aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
            >
                {isFullscreen ? 'EX' : 'FS'}
            </button>
            <style>{`
                .event-video-page {
                    position: fixed;
                    inset: 0;
                    background: #000;
                    overflow: hidden;
                }

                .event-video-frame {
                    position: absolute;
                    inset: 0;
                    width: 100%;
                    height: 100%;
                    border: 0;
                }

                .fullscreen-toggle-button {
                    position: absolute;
                    top: 12px;
                    right: 12px;
                    z-index: 3;
                    width: 34px;
                    height: 34px;
                    border: 1px solid rgba(255, 255, 255, 0.75);
                    border-radius: 6px;
                    background: rgba(0, 0, 0, 0.45);
                    color: #fff;
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 0.5px;
                    cursor: pointer;
                    padding: 0;
                }
            `}</style>
        </div>
    );
}

export default Event;
